var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulkDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 142,
    viewBox: "0 0 400 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150531_28009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.291 113.662L189.515 17.0684L260.462 34.9305L224.643 136.431L150.291 113.662Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.678 102.414L182.902 5.82039L253.849 23.6825L218.03 125.183L143.678 102.414Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.864 109.446C209.47 108.234 213.843 101.896 212.631 95.289C211.419 88.6825 205.08 84.3096 198.474 85.5218C191.867 86.7341 187.494 93.0724 188.707 99.6789C189.919 106.285 196.257 110.658 202.864 109.446Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.521 103.156L194.521 95.4745L195.755 94.9959L198.124 101.068L206.798 94.6644L207.585 95.7272L197.521 103.156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.617 22.9412L192.469 23.5859L235.261 33.4199L235.409 32.7752L192.617 22.9412Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.031 35.3709L186.883 36.0156L229.675 45.8496L229.823 45.2049L187.031 35.3709Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.355 47.2967L181.207 47.9414L223.999 57.7754L224.147 57.1307L181.355 47.2967Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.023 62.4412L175.875 63.0859L218.667 72.9199L218.815 72.2752L176.023 62.4412Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M177.487 52.1596L187.848 56.8528C191.01 58.2837 192.294 62.0967 190.645 65.15L176.937 90.5254C175.005 94.1049 170.614 95.5563 166.926 93.8388L150.306 86.0837L165.583 48.459L177.485 52.1634L177.487 52.1596Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M211.969 71.6843L224.864 42.759L245.448 47.6409L234.952 77.2292L211.969 71.6843Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.015 64.7878L222.911 35.8625L252.379 42.0569L241.024 72.2698L210.015 64.7878Z",
    fill: "#0D9F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.058 40.8783L234.216 33.7885L241.442 35.3042L238.658 42.712L231.058 40.8783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M223.281 44.9276L223.133 45.5723L243.476 50.2474L243.625 49.6027L223.281 44.9276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M221.5 50.4197L221.352 51.0645L241.695 55.7396L241.843 55.0949L221.5 50.4197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M219.234 56.3319L219.086 56.9766L239.43 61.6517L239.578 61.007L219.234 56.3319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.982 59.3342L156.831 49.459L118.497 27.1091C114.137 24.5667 108.539 26.2597 106.316 30.7869C104.094 35.3174 106.18 40.7826 110.855 42.6754L151.982 59.3342Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.746 74.0268L177.488 52.1516C179.497 48.0606 177.809 43.1157 173.717 41.1069L157.955 33.3672C153.864 31.3584 148.919 33.0464 146.911 37.1375L136.169 59.0126C134.16 63.1037 135.848 68.0486 139.94 70.0574L155.702 77.797C159.793 79.8059 164.738 78.1179 166.746 74.0268Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.743 74.0288L177.484 52.1536C179.493 48.0625 177.805 43.1176 173.714 41.1088L161.778 35.2483C157.687 33.2395 152.742 34.9275 150.734 39.0186L139.992 60.8937C137.984 64.9848 139.672 69.9297 143.763 71.9385L155.698 77.799C159.789 79.8078 164.734 78.1198 166.743 74.0288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.68 76.9409L183.421 55.0657C185.43 50.9747 183.742 46.0297 179.651 44.0209L164.857 36.7566C160.766 34.7477 155.821 36.4357 153.812 40.5268L143.071 62.4019C141.062 66.493 142.75 71.4379 146.841 73.4467L161.635 80.7111C165.726 82.7199 170.671 81.0319 172.68 76.9409Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.523 70.2284C164.73 70.374 163.911 70.4402 163.077 70.4184C159.891 70.3405 156.923 69.0288 154.727 66.718C152.528 64.4111 151.361 61.3837 151.439 58.1983C151.597 51.6218 157.081 46.3953 163.658 46.5571C170.235 46.7156 175.458 52.2003 175.299 58.7767C175.159 64.5191 170.965 69.2265 165.526 70.2245L165.523 70.2284ZM161.328 47.4016C156.191 48.3442 152.229 52.7906 152.097 58.2152C152.024 61.2249 153.127 64.0827 155.205 66.2638C157.284 68.4448 160.083 69.6831 163.093 69.7563C169.305 69.9078 174.483 64.9761 174.634 58.7609C174.785 52.549 169.854 47.3707 163.639 47.2198C162.848 47.2001 162.076 47.2643 161.328 47.4016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.438 64.1195L157.428 58.5721L157.922 58.1284L162.35 63.036L168.138 54.0613L168.692 54.4204L162.438 64.1195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.494 22.6181L155.012 26.7793L155.58 27.1182L158.063 22.9571L157.494 22.6181Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.549 25.4475L144.238 26.0312L148.515 28.31L148.826 27.7262L144.549 25.4475Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.226 21.6105L150.586 21.7773L151.807 26.4631L152.447 26.2962L151.226 21.6105Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.092 35.4795C117.018 35.1261 118.293 33.2782 117.939 31.3521C117.586 29.4261 115.738 28.1512 113.812 28.5046C111.886 28.858 110.611 30.7059 110.964 32.632C111.318 34.5581 113.165 35.833 115.092 35.4795Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150531_28009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 142,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkDownload);
export default __webpack_public_path__ + "static/media/bulk_download.687438e3a89762524b459052d3bbd142.svg";
export { ForwardRef as ReactComponent };